import { PROD_API_URL } from './apiConfig';
import { Environment } from './environment.model';

export const environment: Environment = {
  iconUrl: '/my-documents-resources/assets/icons/',
  production: true,
  apiRootUrl: PROD_API_URL,
  apiKey: PROD_API_URL,
  utag: {
    type: 'prod',
    profile: 'main',
    account: 'endress-hauser',
  },
  myResourcesPath: '/my-documents-resources',
};
